import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxGoTopComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxGoTopComponent,
    ],
    exports: [
        AtxGoTopComponent,
    ],
})

export class AtxGoTopModule {}
